import { HTMLProps } from 'react';

import Panel from './Panel';

export interface PanelProps extends HTMLProps<HTMLDivElement> {
	isOpen: boolean;
	onClose?: () => void;
}

export default Panel;